<template>
  <div>
    <b-btn
      id="procedimentoBtn"
      pill
      variant="none"
      style="padding:0.5rem; float:right"
      class="btn-outline-primary"
      @click="mostrarPopover = true"
    >
      <feather-icon
        icon="PaperclipIcon"
      />
    </b-btn>

    <b-popover
      :id="'procedimentos'"
      ref="procedimentos"
      placement="auto"
      target="procedimentoBtn"
      triggers="manual"
      :show.sync="mostrarPopover"
    >
      <div slot="title">
        <span
          class="text-center"
          style="vertical-align: sub"
        >Procedimentos</span>

        <b-button
          variant="none"
          class="close "
          @click="cancelar"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </div>
      <div>
        <b-row>
          <b-col />
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              class="btn-success btn-sm w-100"
              :disabled="!visualizarArquivo"
              @click="visualizar()"
            >Visualizar</b-btn>
          </b-col>
          <b-col
            v-if="efetuaProcedimentos"
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              v-if="adicionarEditar"
              class="btn-success btn-sm w-100"
              @click="editar()"
            >Adicionar</b-btn>
            <b-btn
              v-else
              class="btn-success btn-sm w-100"
              @click="editar()"
            >Editar</b-btn>
          </b-col>
          <b-col
            v-if="efetuaProcedimentos"
            cols="12"
            style="margin-bottom: 0.5rem"
          >
            <b-btn
              class="btn-success btn-sm w-100"
              :disabled="!deletarArquivo"
              @click="remover()"
            >Remover</b-btn>
          </b-col>
        </b-row>

      </div>
    </b-popover>

    <visualizar-arquivo
      v-if="mostrarVisualizacaoArquivo"
      :url="urlArquivo"
      @hidden="fecharVisualizarArquivo()"
    />

    <upload-procedimentos
      v-if="mostrarUploadProcedimentos"
      ref="upload"
      :value="form.arquivoProcedimento"
      @cancelar="cancelarUpload()"
      @hidden="aplicarUpload($event)"
    />
  </div>
</template>

<style lang="scss">
.modal-upload-title {
  margin: 0px;
  font-size: 20px;
}

.vertical-buttons {
  flex-direction: column-reverse;
}

.top-margin {
  margin-top: 1em;
}
</style>

<script src="sweetalert2.all.min.js"></script>
<script>
import { getUserData } from '@/auth/utils'
import api from '@/shared/components/procedimentos/services/api'

export default {
  name: 'Procedimentos',
  components: {
    UploadProcedimentos: () => import('@/shared/components/procedimentos/UploadProcedimentos.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  props: {
    route: {
      type: Object
    }
  },
  watch: {
    route(value, oldValue) {
      if (value != oldValue) {
        this.form.nomeRecurso = this.$route.meta.resource
        api.getURLProcedimento(this.form.nomeRecurso)
          .then(payload => {
            if (payload.data) {
              this.adicionadoArquivo()
            } else {
              this.arquivoDeletado()
            }
          })
      }
    }
  },
  data() {
    return {
      mostrarPopover: false,
      efetuaProcedimentos: false,
      mostrarUploadProcedimentos: false,
      mostrarVisualizacaoArquivo: false,
      urlArquivo: '',
      deletarArquivo: false,
      visualizarArquivo: false,
      adicionarEditar: true,
      form: {
        arquivoProcedimento: null,
        nomeRecurso: '',
        nomeArquivo: '',
        arquivoRequest: null,
      },
    }
  },
  created() {
    this.efetuaProcedimentos = getUserData().efetuaProcedimentos
    this.form.nomeRecurso = this.$route.meta.resource
    api.getURLProcedimento(this.form.nomeRecurso)
    .then(payload => {
      if (payload.data) {
        this.urlArquivo = payload.data
        this.adicionadoArquivo()
        this.adicionarEditar = false
      }
    })
  },
  methods: {
    cancelar() {
      this.mostrarPopover = false
      this.$emit('cancel')
    },
    editar() {
      this.mostrarUploadProcedimentos = true
    },
    remover() {
      this.form.nomeRecurso = this.$route.meta.resource
      api.deleteProcedimento(this.form.nomeRecurso)
        .then(payload => {
          if (payload.data) {
            this.$swal({
              icon: 'success',
              title: 'Removido!',
              text: 'Procedimento removido com sucesso.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.arquivoDeletado()
          } else {
            this.$swal({
              icon: 'info',
              title: '',
              text: 'Não há procedimento anexado.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
        .catch(err => {
          throw err
        })
    },
    visualizar() {
      this.form.nomeRecurso = this.$route.meta.resource
      api.getURLProcedimento(this.form.nomeRecurso)
        .then(payload => {
          if (payload.data) {
            this.urlArquivo = payload.data
            this.mostrarPopover = false
            this.mostrarVisualizacaoArquivo = true
          } else {
            this.$swal({
              icon: 'info',
              title: '',
              text: 'Não há procedimento anexado.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
        .catch(err => {
          throw err
        })
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacaoArquivo = false
    },
    aplicarUpload(file) {
      const axios = require('axios')
      let uploadCancelado = false

      this.form.nomeRecurso = this.$route.meta.resource
      const form = { ...this.form }

      const formData = this.$refs.upload.getFormDataBody(file, form)

      const swal = require('sweetalert2')
      swal.fire({
        title: 'Aguarde, estamos enviando o arquivo para o servidor!',
        willOpen () {
          swal.showLoading()
        },
        didClose () {
          if (swal.DismissReason.cancel) {
            uploadCancelado = true
            api.abortarUpload()
          } else {
            swal.hideLoading()
          }
        },
        showConfirmButton:false,
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          actions: 'vertical-buttons',
          title: 'modal-upload-title',
          cancelButton: 'top-margin'
        }
      })

      api.saveProcedimento(formData, axios.CancelToken)
        .then(() => {
          swal.close()
          this.$swal({
            icon: 'success',
            title: 'Sucesso',
            text: 'Procedimento salvo com sucesso!',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.adicionadoArquivo()
        })
        .catch(err => {
          swal.close()
          if (!uploadCancelado){
            if (!err || typeof err.response === 'undefined') {
              this.$confirmar('Erro', 'Tamanho do arquivo excedeu o limite de 512mb', 'error', '')
            } else {
              this.$handleError(err)
            }
          }
        })

      this.mostrarUploadProcedimentos = false
    },
    cancelarUpload() {
      this.mostrarUploadProcedimentos = false
    },
    arquivoDeletado() {
        this.deletarArquivo = false
        this.visualizarArquivo = false
        this.adicionarEditar = true
    },
    adicionadoArquivo() {
        this.deletarArquivo = true
        this.visualizarArquivo = true
        this.adicionarEditar = false
    }
  },
}
</script>
